import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { callAPI } from "../../../../functions/api";
import { CopyBlock, dracula } from "react-code-blocks";
export const ManualTriggerModal = ({ open, node }) => {
  return (
    <Box>
      <Typography>Hello</Typography>
    </Box>
  );
};
